<template>
    <rkm-row>
        <rkm-col cols="4">
            <rkm-form-select
                :options="data.form.tipoWebservice"
                default-option-text="Inativa"
                label="Integração"
                show-default-option
                text-field="nome"
                v-model="data.model.webserviceTipoId"
                value-field="id"
            />
        </rkm-col>

        <rkm-col class="pt-4">
            <span :id="uniqueId(`webservice-tipo`)">
                <rkm-icon icon="info-circle" />
            </span>

            <rkm-popover
                :target="uniqueId(`webservice-tipo`)"
                placement="top"
                title="Descrição"
                triggers="hover"
            >
                <ul>
                    <li><strong>Parcial:</strong> Somente permite consultar os pedidos onde todos os exames foram coletados.</li>
                    <li><strong>Completa:</strong> Permite consultar os pedidos independente se os exames foram coletados ou não.</li>
                </ul>
            </rkm-popover>
        </rkm-col>
    </rkm-row>
</template>

<script>

export default {
    props: {
        data: { type: Object, required: true },
    },
}
</script>